import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { ToastService } from 'src/app/services/toast.service';
import { StorageService } from 'src/app/services/storage.service';
import { LangService } from '../lang/lang.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class MainService {

	// public baseUrl: 'https://mage.entrelabel.com';
	public lang: LangService;
	constructor(
		public http: HttpClient,
		public toastService: ToastService,
		public storage: StorageService,
		public router: Router
	) { }

	getStoreUrl(path: string = ''){
		return '/rest/' + environment.store_url + path;
	}

	getUrl(path: string = ''){
		return environment.baseUrl + path;
	}

	getHttpOptions(header: any = {}){
		let httpOptions = {
			headers: new HttpHeaders(header)
		};
		return httpOptions;
	}


	put(url, jsonData, header:any = null): Observable<any> {
		if(header){
			return this.http.put<any>(this.getUrl(url), jsonData, this.getHttpOptions(header));
		} else {
			return this.http.put<any>(this.getUrl(url), jsonData);
		}
	}

	post(url, postData, header:any = null, directUrl=false): Observable<any> {
		if(!directUrl){
			url = this.getUrl(url);
		}
		if(header){
			return this.http.post<any>(url, postData, this.getHttpOptions(header));
		} else {
			return this.http.post<any>(url, postData);
		}
	}

	del(url, header:any = null): Observable<any> {
		if(header){
			return this.http.delete<any>(this.getUrl(url), this.getHttpOptions(header));
		} else {
			return this.http.delete<any>(this.getUrl(url));
		}
	}

	get(url, header:any = null): Observable<any> {
		if(header){
			return this.http.get<any>(this.getUrl(url), this.getHttpOptions(header));
		} else {
			return this.http.get<any>(this.getUrl(url));
		}
	}

	errorHandler(error, addClickClearStorage:boolean = true){
		this.setLoader(false);
		if(error.status == 404 && error.url == this.getUrl('/rest/entrelable/V1/customers/password')) {
			this.toastService.add(this.lang.getLang('l66'), 'danger');
		} else {
			if(typeof error['error'] != 'undefined'){
				if(typeof error['error']['message'] != 'undefined'){
					let errorMessage = error.error.message;
					if(typeof error.error.parameters != 'undefined'){
						let objKeys = Object.keys(error.error.parameters);
						objKeys.forEach(key => {
							let val = error.error.parameters[key];
							errorMessage = errorMessage.replace("%"+key, val);
						});
					}

					let testError = errorMessage.toLocaleLowerCase();
					let noSuchEntity = testError.includes('no such entity');
					if(!noSuchEntity){
						this.toastService.add(errorMessage, 'danger');
						// if(addClickClearStorage){
						// 	let msg = 'Click <a href="javascript:void(0)" onclick="window.localStorage.clear(); window.sessionStorage.clear(); window.location.href = \'/\'">here</a> if this error continuously occurs then please sign in again.';
						// 	this.toastService.add(errorMessage + ' - ' + msg, 'danger', 0);
						// }
						// else {
						// 	this.toastService.add(errorMessage, 'danger');
						// }
					}
				}
			}
		}
	}

	setLoader(show:boolean = true){
		this.toastService.setLoader(show);
	}

	/**
	 * make an API call to magento platform
	 * this assumes that the user was already loged in 
	 */
	makeRequest(urlPath: string, jsonData: any, method: string = 'POST', isToastMsg: boolean = true, addClickClearStorage:boolean = true){
		return new Promise(res => {
			this.storage.get('user').then(resolve => {
				let data: any = resolve;
				let header = {
					"Content-Type": 'application/json',
					"Authorization": 'Bearer ' + data.token
				}

				let request = null;
				if(method == 'POST'){
					request = this.post(urlPath, JSON.stringify(jsonData), header)
				}
				else if(method == 'PUT'){
					request = this.put(urlPath, JSON.stringify(jsonData), header)
				}
				else if(method == 'GET'){
					request = this.get(urlPath, header);
				}
				else if(method == 'DELETE'){
					request = this.del(urlPath, header);
				}
				if(request){
					request.subscribe(result => {
						res(result);
					}, error => {
						this.isMaintenanceMode(error);
						if(isToastMsg){
							this.errorHandler(error, addClickClearStorage);
						}
						// if(!this.isMaintenanceMode(error)){
						// 	if(isToastMsg){
						// 		this.errorHandler(error, addClickClearStorage);
						// 	}
						// }
						res(null);
					});
				}
			});
		});
	}

	/**
	 * make an API call to magento platform
	 * this assumes that the user was already loged in 
	 * return object with error and result data
	 */
	 doRequest(urlPath: string, jsonData: any, method: string = 'POST', isToastMsg: boolean = true, isAddHeader: boolean = true, customerHeader:any=null, addClickClearStorage:boolean = true){
		return new Promise(res => {
			this.storage.get('user').then(resolve => {

				let header:any = null;
				if(isAddHeader && resolve){
					let data: any = resolve;
					header = {
						"Content-Type": 'application/json',
						"Authorization": 'Bearer ' + data.token
					}
				}

				if(customerHeader){
					header = customerHeader;
				}

				let request = null;
				if(method == 'POST'){
					request = this.post(urlPath, JSON.stringify(jsonData), header)
				}
				else if(method == 'PUT'){
					request = this.put(urlPath, JSON.stringify(jsonData), header)
				}
				else if(method == 'GET'){
					request = this.get(urlPath, header);
				}
				else if(method == 'DELETE'){
					request = this.del(urlPath, header);
				}
				if(request){
					request.subscribe(result => {
						res({
							error: false,
							result: result
						});
					}, error => {
						this.isMaintenanceMode(error);
						if(isToastMsg){
							this.errorHandler(error, addClickClearStorage);
						}
						// if(!this.isMaintenanceMode(error)){
						// 	if(isToastMsg){
						// 		this.errorHandler(error, addClickClearStorage);
						// 	}
						// }
						res({
							error: error,
							result: false
						});
					});
				}
			});
		});
	}

	/**
	 * check if the error is for maitenance of not
	 * @param error 
	 * @returns 
	 */
	isMaintenanceModeChecking: boolean = false;
	isMaintenanceMode(error:any){
		if(!this.isMaintenanceModeChecking){
			this.isMaintenanceModeChecking = true;

			let url = '/maintenance_check.php';
			this.get(url).subscribe(result => {
				this.isMaintenanceModeChecking = false;
			}, error => {
				this.toastService.isMaintenanceMode = true;
				this.toastService.clearAll();
				this.router.navigate(['server/maintenance']);
				
				this.isMaintenanceModeChecking = false;
			});
		}
		// let mMode:any = false;
		// if(typeof error.error == 'string'){
		// 	mMode = error.error.includes('maintenance mode is enabled');
		// 	if(mMode){
		// 		this.toastService.isMaintenanceMode = true;
		// 		this.toastService.clearAll();
		// 		this.router.navigate(['server/maintenance']);
		// 	}
		// }
		// return mMode;
	}

	ajax(options={}){
		let xhr = new XMLHttpRequest();
		xhr.open(options['method'], options['url']); 
	
		let isJson = false;
		if(typeof options['headers'] != 'undefined'){

			let objKeys = Object.keys(options['headers']);
			objKeys.forEach(key => {
				let val = options['headers'][key];
				xhr.setRequestHeader(key, val);
			});
		}
	
		if(typeof options['uploadProgress'] == 'function'){
			xhr.upload.addEventListener('progress', (e) => {
				let uploadProgress = (e.loaded / e.total)*100;
				options['uploadProgress'](e, uploadProgress);
			});
		}
		if(typeof options['abort'] == 'function'){
			xhr.upload.addEventListener('progress', (e) => {
				options['abort'](xhr);
			});
		}
	
		if(typeof options['success'] == 'function'){
			xhr.addEventListener('load', (e) => {
				if(xhr.status == 200){
					let responseText = xhr.responseText
					if(this.isJsonResponse(xhr.getResponseHeader('content-type'))){
						responseText = JSON.parse(xhr.responseText);
					}
					options['success'](responseText);
				}
			});
		}
		if(typeof options['error'] == 'function'){
			xhr.addEventListener('load', (e) => {
				if(xhr.status != 200){
					let responseText = xhr.responseText
					options['error'](responseText);
				}
			});
		}
		if(typeof options['complete'] == 'function'){
			xhr.addEventListener('loadend', (e) => {
				options['complete'](xhr);
			});
		}
	
		xhr.send(options['data']);
	}
	isJsonResponse(headers){
		let isJson = false;
		let _headers = headers.split(';');
		if(this.inArray('application/json', _headers) ){
			isJson = true;
		}
		return isJson;
	}
	inArray(needle, haystack) {
		var length = haystack.length;
		for(var i = 0; i < length; i++) {
			if(haystack[i] == needle) return true;
		}
		return false;
	}

	getData(key:string, item){
		let data:any = '';
		if(typeof item[key] != 'undefined'){
			data = item[key];
		}
		else {
			if(typeof item.custom_attributes != 'undefined'){
				item.custom_attributes.forEach(custom_attribute => {
					if(custom_attribute.attribute_code == key){
						data = custom_attribute.value
					}
				});
			}
		}
		return data;
	}
}
